// 为打印方法添加样式 - 这里看看是封装一个方法提供，还是覆盖工具的log方法
export const appLog = {
    log: (text: string, data?: any) => {
        const style = 'background: green; padding: 3px; border-radius: 2px;';
        console.log(`%c ${text}`, style, data);
    },
    error: (text: string, data?: any) => {
        const style = 'background: red; padding: 3px; border-radius: 2px;';
        console.error(`%c ${text}`, style, data);
    },
};
